import { css } from '@/styled-system/css';

// Uses standard CSS scrollbar properties instead of ::-webkit-scrollbar hacks.
// scrollbar-width: thin preserves native overlay behavior (no layout shift on macOS)
// and works across Chrome 121+, Firefox, and Safari 18+.

// Always visible thin scrollbar
export const scrollbarStyles = css.raw({
  scrollbarWidth: 'thin',
  scrollbarColor: 'var(--colors-bg-soft) transparent',
});

// Hover-only thin scrollbar (transparent until hovered)
export const scrollbarHoverStyles = css.raw({
  scrollbarWidth: 'thin',
  scrollbarColor: 'transparent transparent',
  '&:hover': {
    scrollbarColor: 'var(--colors-bg-soft) transparent',
  },
});
